export enum LeadStatus {
  New = 0,
  Doubled = 1,
  RepeatedIn1Min = 3,
  InProcess = 4,
  Good = 6,
  Meeting = 7,
  SentEstimate = 8,
  Closed = 9,
  NotClosed = 10,
  NotGood = 11,
  Archives = 12,
  ReturnClients = 15,
  Deleted = 50,
  Ignored = 60,
  IgnoredBot = 61,
}

export const AvailableLeadStatuses: LeadStatus[] = [LeadStatus.New, LeadStatus.Doubled];

export const AvailableSaleStatuses: LeadStatus[] = [LeadStatus.New, LeadStatus.InProcess, LeadStatus.Meeting, LeadStatus.NotGood, LeadStatus.Closed];

export const colorsByLeadStatus = {
  New: "#66bee3",
  Doubled: "#d9acf5",
  RepeatedIn1Min: "#f8f3d4",
  InProcess: "#0f69c9",
  Good: "#00b8a9",
  Meeting: "#ff9724",
  SentEstimate: "#be9fe1",
  Closed: "#269339",
  NotClosed: "#bfdb38",
  NotGood: "#de473c",
  Archives: "#b99b6b",
  ReturnClients: "#4d6b55",
  Deleted: "#fc7300",
  Ignored: "#f9f54b",
  IgnoredBot: "#7f8c8d",
};
